import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Disclosures = () => {
  return (
    <Container className="py-5">
      <Row>
        <Col lg={8} className="mx-auto">
          <h1 className="mb-4">Regulatory Disclosures</h1>
          <p className="text-muted mb-5">
            Last updated: {new Date().getFullYear()}
          </p>

          <div className="mt-4">
            <h3>Risk Warnings</h3>
            <div className="alert alert-warning">
              <strong>Important:</strong> Digital asset trading involves
              substantial risk. You should carefully consider whether trading is
              suitable for you.
            </div>
          </div>

          <div className="mt-4">
            <h3>Regulatory Status</h3>
            <ul>
              <li>
                Authorized and regulated by the Financial Conduct Authority
                (FCA) in the UK
              </li>
              <li>
                Registered with FinCEN as a Money Services Business in the US
              </li>
              <li>Compliant with MiFID II regulations in the European Union</li>
            </ul>
          </div>

          <div className="mt-4">
            <h3>Client Classification</h3>
            <p>
              Our services are available exclusively to professional and
              institutional clients. We do not provide services to retail
              clients.
            </p>
          </div>

          <div className="mt-4">
            <h3>Conflicts of Interest</h3>
            <p>
              We maintain a comprehensive Conflicts of Interest Policy to
              identify and manage potential conflicts in line with regulatory
              requirements.
            </p>
          </div>

          <div className="mt-4">
            <h3>Complaints Procedure</h3>
            <p>
              If you have a complaint about our services, please contact our
              Compliance Officer at complaints@airclift.com
            </p>
          </div>

          <div className="mt-5">
            <p className="text-muted small">
              Airclift Capital Ltd is incorporated in England and Wales (Company
              No. 12345678). Registered office: 1 Angel Court, London EC2R 7HJ,
              UK.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Disclosures;
